import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Money as MoneyField, Radio, RequiredValidator, TextField, useFormContext } from '../../Components/Form';
import Money from '../../Components/Formatting/Money';
import Grid from '../../Components/Formatting/Grid';
import NoValue from '../../Components/EmptyStates/NoValue';
import Alert from '../../Components/Alert';

const EditBalance = ({customer, editBalance, isOpen, setIsOpen}) => {
    return <Modal title="Edit Balance" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{customer, editBalance}} />}
    </Modal>
}

const Inner = ({customer, editBalance}) => {
    return <Form data={{action: null, amount: 0}} onSubmit={editBalance} closeModalOnSubmit>
        <Radio name="action"
            label="Action"
            layout="SmallCards"
            options={[{value: 'creditBalance', label: 'Add credit'}, {value: 'debitBalance', label: 'Remove credit'}]}
            validators={[RequiredValidator]}
        />
        <MoneyField name="amount" label="Amount" validators={[RequiredValidator]} />
        <TextField name="description" label="Reason for change" validators={[RequiredValidator]} />
        <Result customer={customer} />
        <Actions submit={{label: 'Save'}} cancel />
    </Form>
}

const Result = ({customer}) => {
    const {formData} = useFormContext();

    const currentBalance = parseInt(customer.balance ?? 0);
    const action = formData.action;
    const amount = parseInt(formData.amount);
    const newBalance = action === 'creditBalance' ? (currentBalance + amount) : (currentBalance - amount);

    const incomplete = (action !== 'creditBalance' && action !== 'debitBalance') || amount === null;

    return (<>
            <Grid items={[
                ['Current Balance:', <Money pence={currentBalance} colour />],
                ['New Balance:', incomplete ? <NoValue /> : <Money pence={newBalance} colour />]
            ]} />
            {action === 'creditBalance' && <Alert
                theme="info"
                icon="MoneyBillWave"
                message="If the customer paid cash you should use the 'add cash payment' option instead."
            />}
    </>);
}

export default EditBalance;
